import { Box, Typography } from '@mui/material'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { RADIUS } from '@/shared/styles/radii'
import { ICON_SIZE, UI_FONT_SIZE } from '@/shared/styles/typography'

/**
 * 録音中断 (= unrecoverable). mic 奪われ / OS audio session 中断などで録音継続不能.
 * 28 spec §4.7 警告バナーの構造を踏襲しつつ severity を上げて danger token に差し替え.
 * 文言は「何が起きたか + 推測される原因 + ユーザーアクション」 を 3 文で並べる.
 */
export const InterruptionUnrecoverableBanner = () => (
  <Box
    sx={{
      backgroundColor: colorTokens.state.dangerBg,
      color: colorTokens.state.dangerFg,
      borderRadius: `${RADIUS.md}px`,
      py: 1,
      px: 1.5,
      display: 'flex',
      gap: 1,
      alignItems: 'flex-start',
    }}
  >
    <ErrorOutlineRoundedIcon
      sx={{
        color: colorTokens.state.dangerIcon,
        fontSize: ICON_SIZE.md,
        flexShrink: 0,
      }}
    />
    <Typography
      component="span"
      sx={{
        fontSize: UI_FONT_SIZE.label,
        lineHeight: 1.4,
      }}
    >
      録音が中断されました。マイクが利用できない可能性があります。もう一度録音を開始してください。
    </Typography>
  </Box>
)
